// extracted by mini-css-extract-plugin
export var paginationContainer = "_6c-0";